// @flow
import { httpDelete, httpGet, httpPost, httpPut } from '../helpers/helpers.api';

export function getTemplates(templatesVersion: number): Promise<Response> {
    return httpGet(`action-templates?version=${templatesVersion}`);
}

export function getActions(): Promise<Response> {
    return httpGet(`actions`);
}

export function createHiveAction(newAction: {}): Promise<Response> {
    return httpPost(`actions`, newAction);
}

export function editAction(action: {}, id: string): Promise<Response> {
    return httpPut(`actions/${id}`, action);
}

export function removeAction(actionId: string): Promise<Response> {
    return httpDelete(`actions/${actionId}`);
}

export function triggerQuickAction(actionId: string): Promise<Response> {
    return httpPost(`actions/${actionId}/quick-action`);
}



// WEBPACK FOOTER //
// ./src/core/api/actions/actions.api.js